import AddIcon from '@mui/icons-material/Add'
import Button, { ButtonProps } from '@mui/material/Button'
import FormControl, { FormControlProps } from '@mui/material/FormControl'
import cloneDeep from 'lodash/cloneDeep'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps, connectField, filterDOMProps, joinName, useField } from 'uniforms'

export type ListAddFieldProps = FieldProps<
  unknown,
  ButtonProps,
  {
    fullWidth?: FormControlProps['fullWidth']
    icon?: ReactNode
    margin?: FormControlProps['margin']
    variant?: FormControlProps['variant']
    cta?: string
  }
>

function ListAdd({
  cta,
  disabled,
  fullWidth = true,
  icon = <AddIcon />,
  margin = 'dense',
  name,
  readOnly,
  value,
  variant,
  ...props
}: ListAddFieldProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')

  const nameParts = joinName(null, name)
  const parentName = joinName(nameParts.slice(0, -1))
  const parent = useField<{ maxCount?: number }, unknown[]>(
    parentName,
    {},
    { absoluteName: true }
  )[0]
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const limitNotReached = !disabled && !(parent.maxCount! <= parent.value!.length)

  return (
    <FormControl fullWidth={fullWidth} margin={margin} variant={variant}>
      <Button
        data-testid={`list-add-button-${parentName}`}
        variant="text"
        {...filterDOMProps(props)}
        disabled={!limitNotReached}
        endIcon={icon}
        onClick={() => {
          if (!readOnly) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.onChange(parent.value!.concat([cloneDeep(value)]))
          }
        }}
      >
        {cta || t('addItem')}
      </Button>
    </FormControl>
  )
}

export default connectField<ListAddFieldProps>(ListAdd, {
  initialValue: false,
  kind: 'leaf',
})
